import Svg, { type SvgProps } from './Svg';
export { Svg as default, Svg, SvgProps };

export { default as SvgIcon, type SvgIconProps } from "./components/SvgIcon";
export { default as SvgIconDownload } from "./components/SvgIconDownload";
export { default as SvgIconBurger } from "./components/SvgIconBurger";
export { default as SvgIconCaret, type SvgIconCaretProps } from "./components/SvgIconCaret";
export { default as SvgIconInfo } from "./components/SvgIconInfo";
export { default as SvgIconLink } from "./components/SvgIconLink";
export { default as SvgIconSearch } from "./components/SvgIconSearch";
export { default as SvgIconView, type SvgIconViewProps } from "./components/SvgIconView";
export { default as SvgIconX } from "./components/SvgIconX";
export { default as SvgIconZoom, type SvgIconZoomProps } from "./components/SvgIconZoom";